<template lang="pug">
  .support-kb-list
    .support-page-header
      h1 Base de conocimiento
      .support-page-actions
        el-button(@click="goToSources") ⤴ Explorador de fuentes
        el-button(type="primary" @click="goToNew") + Nuevo artículo

    .support-filters
      el-select(v-model="filters.modulo" placeholder="Módulo" clearable size="small" @change="reload")
        el-option(v-for="m in moduloOptions" :key="m" :label="m" :value="m")
      el-select(v-model="filters.scope" placeholder="Scope" clearable size="small" @change="reload")
        el-option(label="global" value="global")
        el-option(label="tenant" value="tenant")
      el-select(v-model="filters.status" placeholder="Estado" clearable size="small" @change="reload")
        el-option(label="published" value="published")
        el-option(label="draft" value="draft")
        el-option(label="archived" value="archived")
      el-input(v-model="filters.q" placeholder="Buscar título..." size="small" clearable @keyup.enter.native="reload" style="width:240px")
      el-button(size="small" @click="reload") Filtrar

    el-table(:data="docs" v-loading="loading" stripe @row-click="goToEdit")
      el-table-column(prop="titulo" label="Título" min-width="240")
        template(slot-scope="s")
          span(v-if="s.row.status === 'draft'")
            el-tag(size="mini" type="info") draft
            | &nbsp;
          | {{ s.row.titulo }}
      el-table-column(prop="modulo" label="Módulo" width="160")
      el-table-column(prop="scope" label="Scope" width="100")
      el-table-column(label="Usos" width="80" align="center")
        template(slot-scope="s") {{ s.row.usage ? s.row.usage.hits : 0 }}
      el-table-column(label="👍 / 👎" width="100" align="center")
        template(slot-scope="s") {{ s.row.usage ? s.row.usage.positive : 0 }} / {{ s.row.usage ? s.row.usage.negative : 0 }}
      el-table-column(label="Editado" width="140")
        template(slot-scope="s") {{ formatDate(s.row.updatedAt) }}

    el-pagination(
      v-if="total > limit"
      background
      layout="prev, pager, next"
      :total="total"
      :page-size="limit"
      :current-page.sync="page"
      @current-change="reload"
    )
</template>

<script>
import supportService from "@/services/support";

/**
 * @component KBList
 * @description Listado de artículos KB del bot de soporte (Fase 2 — UC-REG-098).
 *              Permite filtrar por módulo, scope, audiencia, estado, búsqueda
 *              por título. Click en fila → ir al editor.
 * @example <KBList />
 */
export default {
  name: "KBList",
  data() {
    return {
      docs: [],
      total: 0,
      page: 1,
      limit: 20,
      loading: false,
      filters: {
        modulo: null,
        scope: null,
        status: "published",
        q: "",
      },
      moduloOptions: [
        "historia-clinica",
        "receta-electronica",
        "agenda",
        "validacion",
        "evolucion",
        "evolucion-ia",
        "turnos",
        "sala-atenciones",
        "gestion-pacientes",
      ],
    };
  },
  mounted() {
    this.reload();
  },
  methods: {
    /**
     * @description Refresca la lista con los filtros actuales.
     */
    async reload() {
      this.loading = true;
      try {
        const data = await supportService.listArticles({
          ...this.filters,
          page: this.page,
          limit: this.limit,
        });
        this.docs = data.docs;
        this.total = data.total;
      } catch (err) {
        this.$message.error("No pude cargar la KB.");
      } finally {
        this.loading = false;
      }
    },
    /**
     * @description Navega al editor de un artículo.
     * @param {Object} row
     */
    goToEdit(row) {
      this.$router.push({ name: "support-kb-edit", params: { id: row._id } });
    },
    goToNew() {
      this.$router.push({ name: "support-kb-new" });
    },
    goToSources() {
      this.$router.push({ name: "support-kb-sources" });
    },
    /**
     * @description Formatea fecha relativa simple.
     * @param {string} iso
     * @returns {string}
     */
    formatDate(iso) {
      if (!iso) return "";
      const d = new Date(iso);
      const diffMs = Date.now() - d.getTime();
      const diffMin = Math.round(diffMs / 60000);
      if (diffMin < 60) return `${diffMin} min`;
      const diffHr = Math.round(diffMin / 60);
      if (diffHr < 48) return `${diffHr} h`;
      const diffDay = Math.round(diffHr / 24);
      return `${diffDay} d`;
    },
  },
};
</script>

<style lang="scss" scoped>
.support-page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  h1 {
    margin: 0;
    font-size: 22px;
    color: #002d5e;
  }
}
.support-page-actions {
  display: flex;
  gap: 8px;
}
.support-filters {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 12px;
  flex-wrap: wrap;
}
</style>
